<script>
  let items = []
  let menu_items = []
  let activeMenuIndex = 0
  let isLoading = true
  let query = `?start_date=${getFirstYearInCurrentDecade()}0101`
  
  $: fetch(`/wp-json/ya/v1/menu?n=past_exhibitions_menu`)
    .then((r) => r.json())
    .then((data) => {
      if (data.items) {
        menu_items = data.items
      }
    })

  $: fetch(`/wp-json/ya/v1/exhibitions${query}&per_page=-1`)
    .then((r) => r.json())
    .then((data) => {
      isLoading = false
      items = data
    })

  function handleNavClick(index, start_date, end_date = false) {
    activeMenuIndex = index
    isLoading = true

    if (end_date) {
      query = `?start_date=${start_date}&end_date=${end_date}`
    } else {
      query = `?start_date=${start_date}`
    }
  }

  function getFirstYearInCurrentDecade() {
    const currentYear = new Date().getFullYear();
    const decade = Math.floor(currentYear / 10);
    const firstYearInDecade = decade * 10;

    return firstYearInDecade;
  }
</script>

<div class="ya-grid">
  <!-- Side nav -->
  <div class="col-span-4 md:col-span-12 lg:col-span-2 mb-3 lg:mb-0">
    <nav class="overflow-scroll lg:overflow-visible">
      <ul class="flex lg:block space-x-3 lg:space-x-0 lg:space-y-1">
        {#if menu_items}
          {#each menu_items as item, i}
            <li class:text-purple={activeMenuIndex == i}>
              <button 
                class="font-display font-bold text-xl text-hover-purple" 
                on:click={handleNavClick(i, item.start_date, item.end_date)}
              >{item.name}</button>
            </li>
          {/each}
        {/if}
      </ul>
    </nav>
  </div>
  <!-- Results -->
  <div class="col-span-4 md:col-span-12 lg:col-span-10">
    <div class="ya-grid gap-y-6">
      {#if items}
        {#if isLoading}
          <div>Loading...</div>
        {:else}
          {#each items as item, i}
            <div class="col-span-4">
              <a href="{item.link.url}" target="{item.link.target}" class={`group ${item.link.url ? 'text-hover-purple' : ''}`}>
                <div class="aspect-w-3 aspect-h-2 crop-child mb-1">
                  {@html item.post_thumbnail}
                </div>
                <h3 class="font-display font-bold text-2xl mb-1">{@html item.title}</h3>
                {#if item.formatted_dates}
                  <div class={`exhibition-dates text-base font-bold text-gray-500 transition-colors duration-300 ${item.link.url ? 'group-hover:text-purple' : ''}`}>{@html item.formatted_dates}</div>
                {/if}
                {#if item.secondary_title}
                  <h4 class="font-sans font-bold text-base">{item.secondary_title}</h4>
                {/if}
                <div class="text-base mt-3">{item.excerpt}</div>
              </a>
            </div>
          {/each}
        {/if}
      {/if}
    </div>
  </div>
</div>